export default {"src":"/_next/static/media/polling_animation.4c48472e.gif","height":168,"width":150,"blurWidth":0,"blurHeight":0};